import type { Answers } from '../models/rental-application';

export function getOccupantCount(occupants: number | null | undefined) {
  return Math.max(0, Number(occupants ?? 0));
}

export function getHasOccupants(answers: Answers) {
  return getOccupantCount(answers.occupants) >= 1;
}

export function getIsRenterOccupant(index: number) {
  return index === 0;
}
